import './Header.css'

export const Header = () => {
  return (
    <header className="header">
      <h1>Welcome To Ticketmaster API!</h1>
      <h3>Use the search bar below to find events through Ticketmaster</h3>
    </header>
  );
}
